var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('el-cascader',{ref:"cascader",class:_vm.test,attrs:{"options":_vm.options,"show-all-levels":false,"placeholder":"小区"},on:{"change":_vm.handleChange},model:{value:(_vm.valueMulty),callback:function ($$v) {_vm.valueMulty=$$v},expression:"valueMulty"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }